// D:\Workspace\paperplay\frontend\src\constants\ctaRoutes.ts

import { ROUTE_DEFINITIONS } from './appRoutes';
import { RouteSlug } from './routeSlugs';

/**
 * ROUTE_DEFINITIONS gives you strings for app slugs (login/register/etc).
 * Marketing pages live in MarketingRouting with static paths — include those here too.
 */
type RouteDef =
  | string
  | {
      path: string;
      build?: (params?: Record<string, string | number | undefined>) => string;
    };

const pick = (slug: RouteSlug): RouteDef => ROUTE_DEFINITIONS[slug];

// Centralized CTAs used across marketing pages, footer, hero buttons, etc.
export const CTA_ROUTES = {
  // Auth
  signup: pick(RouteSlug.AUTH_REGISTER), // alias for register
  register: pick(RouteSlug.AUTH_REGISTER),
  login: pick(RouteSlug.AUTH_LOGIN),

  // Marketing top-level
  home: '/',
  features: '/features',
  howItWorks: '/how-it-works',
  pricing: '/pricing',
  testimonials: '/testimonials',
  contact: '/contact',
  about: '/about',
  privateEvents: '/private-events',
  security: '/security',
  terms: '/terms',
  privacy: '/privacy',
  accountDeletion: '/account-deletion',

  // Deep-links into specific sections on Features
  featuresPayments: '/features#payments',
  featuresMoneyFlow: '/features#money-flow',
} as const;

export type CtaKey = keyof typeof CTA_ROUTES;

export function ctaHref(key: CtaKey, params?: Record<string, string | number | undefined>): string {
  const def = CTA_ROUTES[key];
  if (typeof def === 'string') return def;
  if (typeof def.build === 'function') return def.build(params);
  return def.path;
}
